import { render, staticRenderFns } from "./AboutPC.vue?vue&type=template&id=5fdaa20e&scoped=true"
import script from "./AboutPC.vue?vue&type=script&lang=js"
export * from "./AboutPC.vue?vue&type=script&lang=js"
import style0 from "./AboutPC.vue?vue&type=style&index=0&id=5fdaa20e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdaa20e",
  null
  
)

export default component.exports